import type { DateFiscalInfo } from '@calculom/report-designer';

export const MOCK_DATE_FISCAL: DateFiscalInfo = {
  currentYear: 2026,
  currentPeriodStartDate: '2026-01-01',
  currentPeriodEndDate: '2026-01-31',
  fiscalYearStart: '2026-01-01',
  fiscalYearEnd: '2026-12-31',
};
